









































































































import { Component, Vue, Prop, PropSync, Watch, Emit } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { CropsDTO, CropsToCSV } from "@/api/crops/types";
import {formattedAreaInHa} from "@/filters/area"
import {formattedYield, formattedProduction} from "@/filters/yield"
import i18n from "@/i18n";
import { PlotDoctorStatus } from "@/constants/crop";
import JsonCSV from 'vue-json-csv/src/JsonCSV.vue';
@Component({
  name: "CropsTable",
  components: {
    AgroIcons,
    downloadCsv:JsonCSV
  },
  filters: {
    formattedYieldScore(value: string) {
      if (!value) {
        return '';
      }
      return value.split("SCORE_")[1];
    },
    formattedDate(value: Date) {
      if (!value) {
        return '';
      } else {
        const dateAux = new Date(value);
        dateAux.setUTCMinutes(dateAux.getUTCMinutes()+dateAux.getTimezoneOffset());
        return i18n.d(dateAux, 'short');
      }
    },
    formattedAreaInHa,
    formattedYield,
    formattedProduction
  },
})
export default class CropsTable extends Vue {
  @Prop({ type: Array, required: true })
  private cropsList!: CropsDTO[];

  @Prop({ type: Array, default: () => [] })
  private selected!: string[];

  @Prop( { type: String, default: null})
  private hovered!: string | null;

  private selectedCrops: string[] = [];
  private currentSort = 1;
  private currentSortDir: 'asc' | 'desc' = 'desc';
  
  private status = PlotDoctorStatus;

  private created() {
    this.sort(10);
  }

  private sort(s: number) {
    if(s === this.currentSort) {
      this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
    }
    this.currentSort = s;
  }

  private get sortedCrops() {
    return this.cropsList.flat().sort((a,b) => {
      const modifier = (this.currentSortDir === 'asc') ? 1 : -1;

      switch (this.currentSort) {
        case 0:
          return this.compareFn(a.cropLabel, b.cropLabel, modifier);
        case 1:
          return this.compareFn(a.yield, b.yield, modifier);
        case 2:
          return this.compareFn(a.area, b.area, modifier);
        case 4:
          return this.compareFn(this.$t(`crop-types.${a.cropType}`), this.$t(`crop-types.${b.cropType}`), modifier);
        case 5:
          return this.compareFn(a.seedingDate, b.seedingDate, modifier);
        case 6:
          return this.compareHarvestDate(a, b, modifier);
        case 7:
          return this.compareFn(a.yield * a.area, b.yield * b.area, modifier);

        default:
          break;
      }
      return 0;
    });
  }

  private compareFn(a: any, b: any, modifier: 1 | -1) {
    return (a > b) ? modifier : -modifier;
  }

  private compareScore(scoreA: string, scoreB: string, modifier: 1 | -1) {
    const yieldANumber = !!scoreA ? Number(scoreA.split("SCORE_")[1]) : Number.POSITIVE_INFINITY * modifier;
    const yieldBNumber = !!scoreB ? Number(scoreB.split("SCORE_")[1]) : Number.POSITIVE_INFINITY * modifier;

    return this.compareFn(yieldANumber, yieldBNumber, modifier);
  }

  private compareHarvestDate(a: CropsDTO, b: CropsDTO, modifier: 1 | -1) {
    return this.compareFn(a.harvestDate, b.harvestDate, modifier);
  }

  private classifyScore(score: string) {
    if (!score) {
      return '';
    }
    const scoreNumber =  Number(score.split("SCORE_")[1]);

    if (scoreNumber > 75) {
      return 'crops-table__score-A'
    }
    if (scoreNumber >= 50) {
      return 'crops-table__score-B'
    }
    if (scoreNumber >= 25) {
      return 'crops-table__score-C'
    }
    return 'crops-table__score-D';
  }

  @Watch('selectedCrops')
  @Emit('update:selected')
  private onSelectedCrops(selected: string[]) {}

  @Watch('selected')
  private onSelectedChange(selected: string[]) {
    this.selectedCrops = selected;
  }

  private get cropToCSV() {
    return this.cropsList.map(crop => CropsToCSV.withCropDTO(crop));
  }

  private get csvLabels() {
    return {
      'cropLabel': this.$t('crop-table.label'),
      'area': this.$t('crop-table.area-csv'),
      'yield': this.$t('crop-table.yield-csv'),
      'production': this.$t('crop-table.production-csv'), 
      'yieldScore': `${this.$t('crop-table.score')} ${this.$t('crop-table.city-score')}`,
      'yieldScoreMicroRegion': `${this.$t('crop-table.score')} ${this.$t('crop-table.microregion-score')}`,
      'yieldScoreState': `${this.$t('crop-table.score')} ${this.$t('crop-table.state-score')}`, 
      'yieldScoreCountry': `${this.$t('crop-table.score')} ${this.$t('crop-table.country-score')}`,
      'cropType': this.$t('crop-table.culture'),
      'seedingDate': this.$t('crop-table.seeding'), 
      'harvestDate': this.$t('crop-table.harvest')
    }
  }
}
